export default __webpack_public_path__ + "50d3c215ff8a18a58b05c2a9c79e6a6d.png";